import { useState } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import CustomButton from '../ui/CustomButton'
import CloseIcon from '@mui/icons-material/CloseOutlined'
import { Input } from '../ui'

const ExportToXlsxModal = ({
  isOpen,
  onClose,
  onExport,
  title = 'Exportar Archivo',
  description = 'Ingresa el email donde se enviará el archivo',
  isLoading = false
}) => {
  const [email, setEmail] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)

  const handleClose = () => {
    setEmail('')
    setErrorMessage('')
    setIsSuccess(false)
    onClose()
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleExport = async () => {
    if (!email.trim()) {
      setErrorMessage('El email es requerido')
      return
    }

    if (!validateEmail(email)) {
      setErrorMessage('Ingresa un email válido')
      return
    }

    setErrorMessage('')

    try {
      await onExport(email)
      setIsSuccess(true)
      
      setTimeout(() => {
        handleClose()
      }, 2000)
    } catch (error) {
      console.error('Error al exportar:', error)
      setErrorMessage('Hubo un error al exportar el archivo. Inténtalo de nuevo.')
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleExport()
    }
  }

  return (
    <Dialog
      open={isOpen}
      maxWidth={false}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '40%',
          maxWidth: 'none'
        }
      }}
    >
      <DialogContent className='bg-gray-50 p-6 rounded-lg'>
        <div className='flex justify-between items-center mb-4 border-b pb-2'>
          <h3 className='text-xl font-bold'>{title}</h3>
          <button
            className='text-gray-500 hover:text-gray-700'
            onClick={handleClose}
            disabled={isLoading}
          >
            <CloseIcon />
          </button>
        </div>

        {isSuccess ? (
          <div className='text-center py-8'>
            <div className='text-green-600 text-lg font-semibold mb-2'>
              ✓ Archivo enviado a tu email
            </div>
            <p className='text-gray-600'>
              El archivo se ha enviado correctamente a {email}
            </p>
          </div>
        ) : (
          <>
            <p className='text-sm text-gray-600 mb-4'>{description}</p>
            
            <div className='mb-4'>
              <Input
                type='email'
                placeholder='Ingresa tu email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={isLoading}
                className='w-full'
              />
            </div>

            {errorMessage && (
              <div className='mb-4 text-red-600 text-sm'>{errorMessage}</div>
            )}

            <div className='flex justify-end mt-6 space-x-4'>
              <CustomButton
                title='Cancelar'
                color='primary'
                className='px-4 py-2 rounded-full'
                onClick={handleClose}
                disabled={isLoading}
              />
              <CustomButton
                title={isLoading ? 'Exportando...' : 'Exportar'}
                color='accent2'
                className='px-4 py-2 rounded-full'
                onClick={handleExport}
                disabled={isLoading || !email.trim()}
              />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ExportToXlsxModal
